export default __webpack_public_path__ + "static/media/leftarrow.31e7ed18.svg";